import { Injectable } from '@angular/core';
import { TextZoom } from '@capacitor/text-zoom';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TextzoomService {
  appPreferredSizeSubject: BehaviorSubject<number>;
  appPreferredSize: Observable<number>;
  constructor() {
    this.appPreferredSizeSubject = new BehaviorSubject<number>(
      parseFloat(localStorage.getItem('zoomLevel'))
    );
    this.appPreferredSize = this.appPreferredSizeSubject.asObservable();
  }

  public get appPreferredSizeValue(): number {
    return this.appPreferredSizeSubject.value;
  }

  setZoom(value) {
    localStorage.setItem('zoomLevel', value);
    this.appPreferredSizeSubject.next(value);
    TextZoom.set({ value: value });
  }
}
